export default __webpack_public_path__ + "static/media/print-mobile-3.34b747fd.png";